<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >
    <v-card v-cloak>
      <v-card-title class="d-flex justify-space-between">
        {{ $t('console.manageUsers') }}

        <v-btn icon @click="dialog = false;">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text scrollable class="scrollable mt-4">
        <div v-if="isLoading" class="d-flex justify-center my-10">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            :aria-label="$t('common.loading')"
          ></v-progress-circular>
        </div>

        <div v-else>
          <v-form ref="form">
            <v-row>
              <v-col cols="6"><strong>{{ $t('console.userName') }}</strong></v-col>
              <v-col cols="6"><strong>{{ $t('console.group') }}</strong></v-col>
            </v-row>

            <v-row v-for="user in usersList" :key="user.id" class="align-center">
              <v-col cols="6">{{ user.firstname }} {{ user.lastname }}</v-col>
              <v-col cols="6">
                <v-select
                  v-model="userGroups[user.id]"
                  :items="getGroupOptions"
                  flat
                  variant="solo-filled"
                  hide-details
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>


      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn type="submit" class="bg-primary" elevation=0 :loading="isSubmitted"
               :disabled="isSubmitted || this.usersList.length === 0" @click="submitForm">
          {{ $t('common.save') }}
        </v-btn>
        <v-btn variant="text" @click="dialog = false">{{ $t('common.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js';
import { useTenantConnectionsStore } from '@/stores/TenantConnectionsStore.js';
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  mixins: [ DialogActionKeys, DialogModel ],
  name: 'AwayTenantUsersDialog',
  props: {
    tenantConnection: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSubmitted: false,
      isLoading: false,

      errorMessage: '',
      successMessage: '',

      usersList: [],
      userGroups: {},
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.resetForm();
      }
    },
    // tenantConnection: {
    //   handler() {
    //     this.initializeData();
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  methods: {
    resetForm: async function () {
      this.isSubmitted = false;
      this.errorMessage = '';
      this.successMessage = '';
      this.usersList = [];
      this.userGroups = {};

      if (!this.tenantConnection) {
        return;
      }

      try {
        this.isLoading = true;
        const tenantConnectionStore = useTenantConnectionsStore();

        this.usersList = await tenantConnectionStore.awayTenantGetUsers(this.rootNodeId, this.tenantConnection.id);

        for (const user of this.usersList) {
          this.userGroups[user.id] = user.groupid;

          if (user.groupid === null) {
            this.userGroups[user.id] = '';
          }
        }
      } catch (error) {
        console.error(error);
        this.errorMessage = this.$t('backend.system-error');
      } finally {
        this.isLoading = false;
      }
    },
    async submitForm() {
      const { valid } = await this.$refs.form.validate();

      if (!valid) {
        return;
      }

      const formData = this.usersList.map(function (x) {
        return {
          userId: x.id,
          groupId: this.userGroups[x.id].length > 0 ? this.userGroups[x.id] : null,
        };
      }.bind(this));

      try {
        this.isSubmitted = true;

        const tenantConnectionsStore = useTenantConnectionsStore();
        await tenantConnectionsStore.awayTenantUpdateUsers(this.rootNodeId, this.tenantConnection.id, formData);
        this.dialog = false;
        this.$showMessage(this.$t('console.connectionUserGroupsUpdatedSuccessfully'), { type: 'success' });
        await tenantConnectionsStore.refreshAwayTenantsList(this.rootNodeId);
      } catch (error) {
        console.error(error);

        if (error?.response?.data?.error) {
          this.errorMessage = this.$localizeMessage(error.response.data.error);
        } else {
          this.errorMessage = this.$t('backend.system-error');
        }
      } finally {
        this.isSubmitted = false;
      }
    },
  },
  computed: {
    rootNodeId: function () {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    getGroups() {
      return this.tenantConnection?.groups || [];
    },
    getGroupOptions() {
      return [
        ...this.getGroups.map(group => ({
          title: group.name,
          value: group.id,
        })),
        { title: this.$t('console.noGroupSelected'), value: '' },
      ];
    },
  },
};
</script>
